module.exports = __webpack_public_path__ + "media/landing-page/bg-hero-min-2e0e3fd9.svg";